"use client";

import Link from "next/link";
import Image from "next/image";
import orangeBlackLogo from "@/images/Orange Black.png";
import orangeWhiteLogo from "@/images/Orange White.png";

/**
 * Prep5 Logo component with automatic or forced dark/light variants
 * @param {Object} props
 * @param {string} props.className - Additional classes for the link container
 * @param {string} props.imageClassName - Additional classes for the image
 * @param {"light" | "dark" | "auto"} props.variant - Force a specific variant:
 *   - "light": Use dark text logo (for light backgrounds)
 *   - "dark": Use light text logo (for dark backgrounds)
 *   - "auto": Use automatic dark mode switching (default)
 */
export function Prep5Logo({ className = "", imageClassName = "", variant = "auto" }) {
  // When variant is forced, show only that variant
  if (variant === "dark") {
    return (
      <Link href="/" className={`flex items-center ${className}`}>
        <Image
          src={orangeWhiteLogo}
          alt="Salesably Prep5"
          width={180}
          height={48}
          className={`h-12 w-auto ${imageClassName}`}
          priority
        />
      </Link>
    );
  }

  if (variant === "light") {
    return (
      <Link href="/" className={`flex items-center ${className}`}>
        <Image
          src={orangeBlackLogo}
          alt="Salesably Prep5"
          width={180}
          height={48}
          className={`h-12 w-auto ${imageClassName}`}
          priority
        />
      </Link>
    );
  }

  // Auto mode: switch based on dark mode setting
  return (
    <Link href="/" className={`flex items-center ${className}`}>
      {/* Light mode logo (dark text for light backgrounds) */}
      <Image
        src={orangeBlackLogo}
        alt="Salesably Prep5"
        width={180}
        height={48}
        className={`h-12 w-auto dark:hidden ${imageClassName}`}
        priority
      />
      {/* Dark mode logo (light text for dark backgrounds) */}
      <Image
        src={orangeWhiteLogo}
        alt="Salesably Prep5"
        width={180}
        height={48}
        className={`h-12 w-auto hidden dark:block ${imageClassName}`}
        priority
      />
    </Link>
  )
}